import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Text } from '@/components/ui/Typography/Body/Text';
/** 行頭記号 */
const symbols = {
    base: 'before:content-["※"]',
    dot: 'before:content-["・"]',
    rhombus: 'before:content-["◆"]',
    square: 'before:content-["■"]',
};
const indents = {
    lg: '-indent-[calc(18px+4px)] ml-[calc(18px+4px)]',
    md: '-indent-[calc(15px+4px)] ml-[calc(15px+4px)]',
    none: '-indent-[calc(1em+4px)] ml-[calc(1em+4px)]',
    sm: '-indent-[calc(13px+4px)] ml-[calc(13px+4px)]',
    xs: '-indent-[calc(11px+4px)] ml-[calc(11px+4px)]',
};
/**
 * 行頭に"※"などの文字列ありでテキスト表示させるためのコンポーネント
 * @description 既存で".text-liststyle"系のセレクタがある場合、本コンポーネントに置き換えてください
 * @param props
 * @constructor
 */
export const WithAnnotationText = (props) => {
    const { children, className = '', color, isBold, isIndent = true, size = 'md', symbol = 'base', } = props;
    return (_jsx(Text, Object.assign({ className: clsx('before:mr-4', isIndent && indents[size], symbols[symbol], className), color: color, isBold: isBold, size: size }, { children: children })));
};
export const withAnnotationTextSymbols = symbols;
